import React, { Component } from "react";
import styles from "./CareerSearch.scss";
import Job from "./Job";
import Loader from "../../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import sectors from "./Sectors.js";
import classnames from "classnames";
import { findSimilarJobs } from "../../../actions/Careers/findSimilarJobs";

export default class CareerSearchMatching extends Component {
  constructor(props) {
    super(props);
    this.state = {
      job_num: undefined,
      selectedSector: { value: undefined, label: "Select..." },
      loading: false,
      showSimilar: [],
      hideSimilar: [],
      start_search: false,
      resulting_jobs: [],
      display_jobs: undefined
    };
  }

  componentDidMount() {
    // Get all jobs
    this.getAllJobsFromCategory();
    // Set jobs
    this.setState({
      display_jobs: this.props.jobs,
      job_num: Math.floor(Math.random() * (this.props.jobs.length - 1))
    });
  }

  componentWillUnmount() {
    this.props.resetToOriginalState();
  }

  async componentDidUpdate(prevProps, prevState) {
    // // if they found three jobs they like
    // if (this.state.showSimilar.length === 3 &&
    // this.state.start_search === false){
    //   // CHANGE CALL SO THAT IT PASSES ALL, NOT JUST FIRST
    //   // HOWEVER, WAIT UNTIL PYTHON SCRIPT IS CHANGED
    //   await findSimilarJobs(this.state.showSimilar, this.setResultingJobs)
    //   this.setState({
    //     start_search: true,
    //     loading: true
    //   })
    // }

    // if new sector is selected, change display jobs
    if (prevState.selectedSector !== this.state.selectedSector) {
      this.getAllJobsFromCategory();
    }
  }

  async searchSimilarJobs() {
    await findSimilarJobs(this.state.showSimilar, this.setResultingJobs);
    this.setState({
      start_search: true,
      loading: true
    });
  }

  setResultingJobs = result => {
    this.setState({
      resulting_jobs: result,
      loading: false
    });
  };

  getAllJobsFromCategory = () => {
    if (this.state.selectedSector.label === "Select...") {
      this.setState({
        display_jobs: this.props.jobs,
        job_num: Math.floor(Math.random() * (this.props.jobs.length - 1))
      });
    } else {
      var filteredJobs = [];
      for (var i = 0; i < this.props.jobs.length; i++) {
        var job = this.props.jobs[i];
        if (job.sectors.includes(this.state.selectedSector.label)) {
          filteredJobs = [...filteredJobs, job];
        }
      }
      this.setState({
        display_jobs: filteredJobs,
        job_num: Math.floor(Math.random() * (filteredJobs.length - 1))
      });
    }
  };

  handleChange = selectedSector => {
    this.setState({ selectedSector: selectedSector });
  };

  ShowSimilar = id => {
    this.setState({
      showSimilar: [...this.state.showSimilar, id],
      job_num: Math.floor(Math.random() * (this.state.display_jobs.length - 1))
    });
  };

  RemoveFromSimilar = id => {
    this.setState({
      showSimilar: this.state.showSimilar.filter(job => job !== id)
    });
  };

  NotInterested = id => {
    this.setState({
      hideSimilar: [...this.state.hideSimilar, id],
      job_num: Math.floor(Math.random() * (this.state.display_jobs.length - 1))
    });
  };

  render() {
    if (
      this.props.jobs.length === 0 ||
      this.props.jobs === undefined ||
      this.state.job_num === undefined
    ) {
      return <Loader />;
    } else if (this.state.loading === true) {
      return (
        <div className={styles.JobsBox}>
          <div className={styles.title}>
            <h6>{"Finding the perfect jobs for you..."}</h6>
          </div>
          <Loader />
        </div>
      );
    } else if (this.state.resulting_jobs.length > 0) {
      return (
        <div className={styles.JobsBox}>
          <div className={styles.title}>
            <h6>
              {
                "These results are based on jobs you said you were interested in:"
              }
            </h6>
          </div>
          <div className={styles.DisplayJobsBox}>
            {this.state.resulting_jobs.map(id => {
              var job = this.props.jobs.find(job => {
                return job._id === id;
              });
              return <Job key={job._id} job={job} />;
            })}
            </div>
          </div>
      );
    } else {
      return (
        <div className={styles.JobsBox}>
          <div className={styles.title}>
            <h5>
              Pick three jobs that interest you.
              Then, click the "Search for Similar Jobs!"
              button to see jobs we recommend for you!
            </h5>
            <p>{"Filter by sector:"}</p>
            <div className={styles.dropdown}>
              <Select
                className={styles.select}
                value={this.state.selectedSector}
                onChange={this.handleChange}
                options={sectors}
              />
            </div>

            {this.state.showSimilar.length >= 3 && (
              <div className={styles.search}>
                <button
                  onClick={() => this.searchSimilarJobs()}
                  className={classnames(
                    styles.SearchSimilarButton,
                    "btn z-depth-0"
                  )}
                >
                  Search For Similar Jobs!
                </button>
              </div>
            )}
          </div>
          <div className={styles.selectBox}>
          {this.state.selectedSector.value !== undefined &&
            this.state.display_jobs[this.state.job_num] && (
              <Job
                key={this.state.display_jobs[this.state.job_num]._id}
                job={this.state.display_jobs[this.state.job_num]}
                showSimilarButtons={true}
                ShowSimilar={this.ShowSimilar}
                NotInterested={this.NotInterested}
              />
            )}
          </div>

          {this.state.showSimilar.length > 0 && (
            <div className={styles.title}>
              <p>{"Jobs you've marked as interesting:"}</p>
              <div className="row col-12 p-1 mx-0">
                {this.state.showSimilar.map(id => {
                  var job = this.props.jobs.find(job => {
                    return job._id === id;
                  });
                  return (
                    <div className="alert alert-secondary my-1 mx-1 p-2 col-3" role="alert" key={id}>
                      <FontAwesomeIcon
                        style={{ float: "right", height: "10px" }}
                        icon={faTimes}
                        onClick={() => this.RemoveFromSimilar(id)}
                      />
                      <p className={styles.interested}>{job.title.slice(0, 30)}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Careers/CareerSearchMatching.js